import { render, staticRenderFns } from "./serviceProviderList.vue?vue&type=template&id=a78c6ca0&scoped=true&"
import script from "./serviceProviderList.vue?vue&type=script&lang=js&"
export * from "./serviceProviderList.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderList.vue?vue&type=style&index=0&id=a78c6ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78c6ca0",
  null
  
)

export default component.exports